import React from 'react';
import { Box, IconButton, Slide, Typography } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { getNextMonthName } from '../lib/getNextMonthName';
import { grey } from '@mui/material/colors';

interface MonthlyPlansWidgetProps {
  timeLeft: { days: number; hours: number; minutes: number; seconds: number };
  isWidgetVisible: boolean;
  onClick: () => void;
  onClose?: () => void;
}

export const MonthlyPlansWidget = ({
  timeLeft,
  isWidgetVisible,
  onClick,
  onClose,
}: MonthlyPlansWidgetProps) => {
  const formatTime = (days: number, hours: number) => {
    return `${days}д ${hours}ч`;
  };

  return (
    <Slide
      in={isWidgetVisible}
      direction="up"
      mountOnEnter
      unmountOnExit
      appear
    >
      <Box
        sx={{
          position: 'fixed',
          bottom: '15%',
          right: 20,
          backgroundColor: '#FFB300',
          color: '#fff',
          borderRadius: '12px',
          padding: '12px 16px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
          zIndex: 1000,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '8px',
          width: '90px',
          height: '90px',
          cursor: 'pointer',

          '&:hover': {
            backgroundColor: '#FFA000',
            boxShadow: '0 6px 24px rgba(0,0,0,0.2)',
          },
        }}
        onClick={onClick}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '4px',
          }}
        >
          <Typography
            sx={{
              fontSize: '16px',
              fontWeight: 500,
              lineHeight: 1.2,
              textAlign: 'center',
            }}
          >
            планы {getNextMonthName(true)}
          </Typography>

          <Box
            sx={{
              width: '100%',
              height: '1px',
              backgroundColor: '#fff',
              my: '2px',
            }}
          />

          <Typography
            sx={{
              fontSize: '12px',
              fontWeight: 600,
              lineHeight: 1.2,
            }}
          >
            {formatTime(timeLeft.days, timeLeft.hours)}
          </Typography>
        </Box>

        {onClose && (
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              onClose();
            }}
            sx={{
              position: 'absolute',
              top: '-8px',
              right: '-8px',
              backgroundColor: '#fff',
              color: grey[500],
              width: 24,
              height: 24,
              '&:hover': {
                backgroundColor: '#f5f5f5',
                color: grey[700],
              },
            }}
          >
            <CloseIcon sx={{ fontSize: 16 }} />
          </IconButton>
        )}
      </Box>
    </Slide>
  );
};
